import encodeFormData from "../../js/encodeFormData/encodeFormData";
import pigeon from '../../../utilities/js/pigeon/pigeon.js';
import scrollToElement from '../../js/scrollToElement/scrollToElement';

const FormMixin = {
  props: {
    successUrl: {
      type: String,
      default: null
    },
    action: {
      type: String,
      default: null,
    },
    method: {
      type: String,
      default: 'POST'
    },
    contentType: {
      type: String,
      default: 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      innerSuccessUrl: this.successUrl,
      innerAction: this.action
    }
  },
  methods: {
    submitAjaxFormVee4(values, onError, onSuccess) {
      const vm = this;
      let data = { ...values };
      data[this.$refs.csrf.getName()] = this.$refs.csrf.getValue();

      fetch(this.innerAction, {
        method: this.method,
        credentials: 'same-origin',
        headers: {
          'Content-Type': this.contentType,
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: encodeFormData(data)
      })
        .then(res => res.json())
        .then(response => {
          if (response.fieldErrors && response.fieldErrors.length > 0) {
            onError?.(response.fieldErrors)
            vm.$nextTick(() => {
              if (vm.id) {
                pigeon.publish('formsubmit:error', vm.id);
              }

              const firstInvalidInput = vm.errors && Object.keys(vm.errors)
                .map(error => vm.$el.querySelector(`[name="${error.field}"]`))
                .find(element => element.getAttribute('type') !== 'hidden')
              if (firstInvalidInput) {
                scrollToElement(firstInvalidInput, 20);
              }
            });
          } else if (response.redirectOnRestriction) {
            window.location.href = response.redirectOnRestriction;
          } else {
            if (vm.innerSuccessUrl) {
              window.location.href = vm.innerSuccessUrl;
            }

            onSuccess?.()
            if (vm.id) {
              pigeon.publish('formsubmit:success', vm.id);
            }
          }
        })
        .catch(reason => {
          pigeon.publish('GlobalAppError:show', { error: `Server repsonded with status ` + reason })
        });
    },
  }
};

export default FormMixin;
